import { useEffect } from "react";
import { Navigate } from "react-router-dom";

/**
 * Legacy admin route. Kept as a redirect to the unified `/mission-control-51`
 * console (payouts + cofre are now the first tab there).
 */
export default function AdminPayouts() {
  useEffect(() => {
    // No-op: state was migrated but keep hook so future analytics can hook here.
  }, []);
  return <Navigate to="/mission-control-51?tab=payouts" replace />;
}
